import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DashboardRoute, HomeRoute } from "../../../../core/routes/route_constants";
import { useSelector, useDispatch } from "react-redux";
import "./style/menu_layout.css";
import { PageNotFound } from "../../../../core/routes/route_constants";
import { getUser, getActiveTiers } from "../../page/profile/state/profile_slice";
import { chatActions } from "../../di/di";

function determineOverlay(width) {
  if (width > 1024) {
    return false;
  } else {
    return true;
  }
}

function determineAllowToggle(width) {
  if (width > 1024) {
    return false;
  } else {
    return true;
  }
}

function determineSideMenuVisibility(width) {
  if (width > 1024) {
    return true;
  } else {
    return false;
  }
}

function getInitialTabIndex(params, navigate) {
  // Check Route Parameter to know what is the selected tab
  console.log("CURRENT TAB", params.tab);
  if (params.tab === undefined) {
    return 0;
  } else if (params.tab === "chat") {
    return 0;
  } else if (params.tab === "discover") {
    return 1;
  } else if (params.tab === "profile") {
    return 2;
  } else {
    navigate(PageNotFound);
  }
}

function updateURLByIndex(index, navigate) {
  if (index === 0) {
    navigate(DashboardRoute + "/chat");
  } else if (index === 1) {
    navigate(DashboardRoute + "/discover");
  } else if (index === 2) {
    navigate(DashboardRoute + "/profile");
  } else {
    navigate(PageNotFound);
  }
}

// Added new function to determine if mobile view
function isMobileView(width) {
  return width <= 1024;
}

const MenuLayoutComponent = ({ chatContent = <div />, galleryContent = <div />, settingsContent = <div /> }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const [isOpen, setIsOpen] = useState(determineSideMenuVisibility(window.innerWidth));
  const [enableOverlay, setEnableOverlay] = useState(determineOverlay(window.innerWidth));
  const [allowToggle, setAllowToggle] = useState(determineAllowToggle(window.innerWidth));
  const [selectedTabIndex, setSelectedTabIndex] = useState(getInitialTabIndex(params, navigate));
  // New state for tracking mobile view
  const [isMobile, setIsMobile] = useState(isMobileView(window.innerWidth));
  const [uiLoaded, setUILoaded] = useState(false);

  const avatarProfile = useSelector((state) => state.modelProfile.profile);
  console.log("🚀 ~ MenuLayoutComponent ~ avatarProfile:", avatarProfile);
  const userInfo = useSelector((state) => state.user.user);
  const menuToggleFlag = useSelector((state) => state.menu.menuToggleFlag);
  const menuGalleryToggleFlag = useSelector((state) => state.menu.menuGalleryToggleFlag);
  const menuChatToggleFlag = useSelector((state) => state.menu.menuChatToggleFlag);
  const didPerformVideoCall = useSelector((state) => state.chat.didPerformVideoCall);
  const disableResizeFunctions = useSelector((state) => state.menu.disableResizeFunctions);

  const toggleDrawer = () => {
    if (allowToggle) {
      setIsOpen((prevState) => !prevState);
    }
  };
  const closeDrawerOnSelect = () => {
    if (allowToggle) {
      setIsOpen(false);
    }
  };
  const handleSelectTab = (index) => {
    updateURLByIndex(index, navigate);
    setSelectedTabIndex(index);
    closeDrawerOnSelect();

    // Profile Selected
    if (index === 2 && didPerformVideoCall) {
      console.log("REFETCH USER DETAILS");
      // Refetch profile state to get the latest usage
      dispatch(getUser());
      dispatch(getActiveTiers());
      // Set back to false to prevent the App from fetching the user details upon selecting profile tab.
      dispatch(chatActions.setDidPerformVideoCall(false));
    }
  };

  useEffect(() => {
    if (uiLoaded) {
      toggleDrawer();
    }
  }, [menuToggleFlag]);

  useEffect(() => {
    if (uiLoaded) {
      handleSelectTab(1);
    }
  }, [menuGalleryToggleFlag]);

  useEffect(() => {
    if (uiLoaded) {
      handleSelectTab(0);
    }
  }, [menuChatToggleFlag]);

  useEffect(() => {
    const handleResize = () => {
      if (!disableResizeFunctions) {
        setEnableOverlay(determineOverlay(window.innerWidth));
        setAllowToggle(determineAllowToggle(window.innerWidth));
        setIsOpen(determineSideMenuVisibility(window.innerWidth));
        setIsMobile(isMobileView(window.innerWidth));
      }
    };

    if (!disableResizeFunctions) {
      handleResize();
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch, disableResizeFunctions]);

  useEffect(() => {
    setUILoaded(true);
  }, []); // Empty dependency array ensures this runs only once.

  return (
    <div className="flex h-dvh overflow-hidden">
      {/* Sidebar */}
      <div
        className={`w-60 flex-shrink-0 bg-gradient-to-b from-slate-950/80 via-fuchsia-950/80 to-gray-950/80  backdrop-blur-md border-r border-red-900/20 flex flex-col transition-all duration-300 ${
          !isOpen ? "-ml-60 w-0" : ""
        } ${isMobile ? "z-[60] bg-slate-900/80 absolute h-dvh top-0 left-0" : ""} `}
      >
        <div className="h-16 px-6 border-b border-red-900/20 flex items-center justify-center transition-all duration-500">
          <div onClick={() => navigate(HomeRoute)} className="text-2xl font-bold menu-shimmer-effect cursor-pointer">
            ErotiXAI
          </div>
        </div>

        {/* border-white/10 */}
        <div className="p-6 flex flex-col items-center space-y-2 border-b border-red-900/20">
          <div className="relative">
            <div className="w-[7rem] h-[7rem] rounded-full bg-gradient-to-r from-red-700 to-red-800 flex items-center justify-center p-1 animate-glow">
              <div className="w-full h-full rounded-full bg-slate-900 flex items-center justify-center online-indicator overflow-hidden">
                {avatarProfile?.profile === null ||
                  (avatarProfile?.profile === "" && <div className="absolute inset-0 bg-gradient-to-b from-red-800/50 to-transparent"></div>)}
                <div
                  className="absolute rounded-full w-[7rem] h-[7rem] flex items-center justify-center overflow-hidden"
                  style={{ background: `url('/images/eve_profile.webp') top / cover`, backgroundRepeat: "no-repeat" }}
                />

                {/* <div className="absolute w-full h-full flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-heart text-red-300 animate-pulse-soft"
                  >
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                  </svg>
                </div> */}
                {(avatarProfile?.profileUrl ?? "") !== "" && (
                  <div
                    className="absolute rounded-full w-[7rem] h-[7rem] flex items-center justify-center overflow-hidden"
                    style={{ background: `url('${avatarProfile?.profileUrl}') top / cover`, backgroundRepeat: "no-repeat" }}
                  />
                )}
              </div>
            </div>
            <div className="absolute bottom-1 right-1 bg-slate-900 rounded-full p-1 shadow-lg animate-float">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-heart text-red-300"
              >
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
            </div>
          </div>
          <h2 className="text-xl font-bold mt-3">Eve</h2>
          <p className="text-sm text-pink-200">Your AI Companion</p>
          <div className="flex items-center space-x-2 mt-1 bg-red-900/20 px-3 py-1 rounded-full">
            <span className="h-2 w-2 bg-green-500 rounded-full"></span>
            <span className="text-xs text-green-400 font-medium">Online</span>
          </div>
        </div>

        <div className="flex flex-col flex-1 p-4 w-full">
          <button
            className={`text-base nav-button w-full py-3 px-4 mb-3 flex items-center justify-center font-medium transition-all shadow-md ${
              selectedTabIndex === 0 ? "active" : ""
            }`}
            onClick={() => handleSelectTab(0)}
          >
            Chat
          </button>
          {/* <button
            className={`text-base nav-button w-full py-3 px-4 flex items-center justify-center font-medium transition-all ${selectedTabIndex === 1 ? "active" : ""
              }`}
            onClick={() => handleSelectTab(1)}
          >
            Discover
          </button> */}
        </div>

        <div className="flex h-[5.2rem] border-t border-red-900/20 px-4 justify-center items-center">
          <button
            className={`text-base nav-button w-full py-3 px-4 bg-red-900/20 hover:bg-red-800/30 rounded-lg flex items-center justify-center font-medium transition-all hover:shadow-md active:translate-y-0.5 active:shadow-none ${
              selectedTabIndex === 2 ? "active" : ""
            }`}
            onClick={() => handleSelectTab(2)}
          >
            {userInfo?.name || "User"}
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className={`flex-1 flex flex-col h-dvh overflow-hidden ${isMobile && isOpen ? "pl-0" : ""}`}>
        {/* Toggle button */}
        {/* {allowToggle && (
                    <button
                        className="absolute top-4 left-4 z-20 bg-red-900/30 hover:bg-red-800/40 p-2 rounded-lg transition-all"
                        onClick={toggleDrawer}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu">
                            <line x1="4" x2="20" y1="12" y2="12"></line>
                            <line x1="4" x2="20" y1="6" y2="6"></line>
                            <line x1="4" x2="20" y1="18" y2="18"></line>
                        </svg>
                    </button>
                )} */}

        {/* Content area */}
        <div className="flex-1 overflow-auto custom-scrollbar">
          <div className={`${selectedTabIndex === 0 ? "" : "hidden"}`}>{chatContent}</div>
          <div className={`${selectedTabIndex === 1 ? "" : "hidden"}`}>{galleryContent}</div>
          <div className={`${selectedTabIndex === 2 ? "" : "hidden"}`}>{settingsContent}</div>
        </div>
      </div>

      {/* Overlay when sidebar is open on mobile */}
      {enableOverlay && isOpen && <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={toggleDrawer}></div>}

      <div></div>
    </div>
  );
};

export default MenuLayoutComponent;
